import React from "react";
import Routes from "./routes";
import GlobalStyle from "./settings/global";

function App() {
  return (
    <>
      <Routes />
      <GlobalStyle />
    </>
  );
}

export default App;
